import { render, staticRenderFns } from "./EditConcept.vue?vue&type=template&id=6863a85e&scoped=true&"
import script from "./EditConcept.vue?vue&type=script&lang=ts&"
export * from "./EditConcept.vue?vue&type=script&lang=ts&"
import style0 from "./EditConcept.vue?vue&type=style&index=0&id=6863a85e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6863a85e",
  null
  
)

export default component.exports